// Vincular um login que já existe a uma ficha que já existe (Lucas, Felipe:
// ficha sem login; ou a conferência apontando um login sem ficha). Religa as
// horas anotadas antes do vínculo. Sem login para escolher, abre "Nova
// pessoa" no modo religar (cria o login e liga).
import { useEffect, useMemo, useState } from 'react';
import { Alert, Button, Flex, Modal, Select, Typography, App as AntApp } from 'antd';
import { acaoPessoa, type Conferencia } from './apiPessoas';

const { Text } = Typography;

export default function ModalVincularLogin({ aberto, ficha, onClose, onSalvo, onCriarLogin }: {
  aberto: boolean;
  ficha: { id: string; nome: string };
  onClose: () => void;
  onSalvo: (r: any) => void;
  onCriarLogin: () => void;
}) {
  const { message } = AntApp.useApp();
  const [logins, setLogins] = useState<Conferencia['logins_sem_ficha']>([]);
  const [email, setEmail] = useState<string | undefined>(undefined);
  const [carregando, setCarregando] = useState(false);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    if (!aberto) return;
    setEmail(undefined); setCarregando(true);
    acaoPessoa<Conferencia>('pessoa_conferencia').then((c) => setLogins(c.logins_sem_ficha || []))
      .catch((e) => message.error('Não foi possível listar os logins: ' + e.message))
      .finally(() => setCarregando(false));
  }, [aberto, message]);

  const opcoes = useMemo(() => logins.map((l) => ({ value: l.email, label: `${l.nome ? `${l.nome} · ` : ''}${l.email}${l.enabled ? '' : ' (bloqueado)'}` })), [logins]);

  async function vincular() {
    if (!email) { message.warning('Escolha o login.'); return; }
    setSalvando(true);
    try {
      const r = await acaoPessoa('pessoa_vincular_login', { email, profissional_id: ficha.id });
      onSalvo(r);
    } catch (e: any) { message.error(e.message, 8); }
    finally { setSalvando(false); }
  }

  return (
    <Modal open={aberto} onCancel={() => !salvando && onClose()} footer={null} title={`Vincular login a ${ficha.nome}`}
      width="94vw" style={{ maxWidth: 560, top: 24 }} destroyOnHidden>
      <Flex vertical gap={10} style={{ marginTop: 8 }}>
        <Text>Só aparecem logins que ainda não estão ligados a nenhuma ficha. As horas já anotadas com o login escolhido passam a contar para esta ficha.</Text>
        <Select style={{ width: '100%' }} value={email} onChange={setEmail} loading={carregando} allowClear
          showSearch optionFilterProp="label" options={opcoes} placeholder="Escreva o nome ou o e-mail" />
        {!carregando && logins.length === 0 && <Alert type="info" showIcon message="Nenhum login solto. Crie um login novo para esta ficha." />}
        <Flex justify="space-between" gap={8} wrap>
          <Button onClick={() => { onClose(); onCriarLogin(); }}>Criar login novo para esta ficha</Button>
          <Flex gap={8}>
            <Button onClick={onClose} disabled={salvando}>Voltar</Button>
            <Button type="primary" loading={salvando} disabled={!email} onClick={vincular}>Vincular</Button>
          </Flex>
        </Flex>
      </Flex>
    </Modal>
  );
}
